






























import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import AppContentFavoriteIconButton from '~/components/partials/App/AppContentFavoriteIconButton.vue';
import ProducingAreaFlag from '~/components/partials/ProducingArea/ProducingAreaFlag.vue';
import { useListFavorite } from '~/composables/contents/useListFavorite';
import { useWOVNio } from '~/composables/wovn/useWOVNio';
import { CommonProducingArea } from '~/types/common';
import { DisplayLang, FavoriteTypes } from '~/enums';

export default defineComponent({
  components: {
    ProducingAreaFlag,
    AppContentFavoriteIconButton,
  },
  props: {
    producingAreas: {
      type: Array as PropType<CommonProducingArea[]>,
      required: true,
    },
    nameJa: {
      type: String,
      default: '',
    },
    nameEn: {
      type: String,
      default: '',
    },
    producerId: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { currentLang } = useWOVNio();
    const { checkIsFavorite } = useListFavorite();

    const isFavorite = computed(() => checkIsFavorite(props.producerId, FavoriteTypes.PRODUCER));

    return {
      currentLang,
      DisplayLang,
      isFavorite,
    };
  },
});
